window.DigitalFeedback = window.DigitalFeedback || {};
export default window.DigitalFeedback;